// extracted by mini-css-extract-plugin
export default {"bg":"TipsPop_bg__yZr8g","container":"TipsPop_container__Xr1sQ","tipsbg":"TipsPop_tipsbg__gCTtc","tipsmsg":"TipsPop_tipsmsg__Wtt3e","animate-rotate":"TipsPop_animate-rotate__xZ8wl"};